<template>
  <PageLoader v-if="isloading"/>
  <HeadWithLogo/>
  <h4>آموزش قوانین و نکات مربوط به سامانه بر خط ناظر یک</h4>
  <br/>
  <p class="text-justify bold-p">در صورت علاقه به ثبت نام نهایی در سامانه برخط ناظر یک، بایستی این قوانین را با دقت
    تمام مطالعه کنید و
    به سوالات صفحه بعد پاسخ دهید.<span class="text-danger">
                    بدیهی است در صورت عدم شرکت در آزمون و کسب امتیاز لازم در پاسخ به سوالات، تایید نهایی شما
                  برای دریافت نرم افزار سامانه بر خط ناظر یک لغو می گردد .</span>
    <br>
    1. در سامانه ناظر صرفا موارد کشف حجاب بانوان (فقط برداشتن کامل شال وروسری ازسر) ثبت می گردد و استفاده برای سایر جرایم ممنوع است.
    توضیح: حتماً باید از خانم بودن فرد رویت شده اطمینان حاصل کرد. در مواردی شخص از کنار یا پشت سر و با موهای بلند و کاملاً شبیه خانم ها دیده میشود، در صورتی که آقاست و یا خانمی روسری اش عقب رفته ولی افتاده نیست که از لحاظ قانونی در این سامانه کشف حجاب محسوب نمی شود.<br>


    2. عدم دقت در ثبت تخلف یا پلاک باعث ایجاد آسیب‌ها و آفاتی مانند حق‌الناس و اختلاف بین خانواده و دوستان می‌شود. پس بدون اطمینان از انجام قطعی تخلف و اطمینان از تطابق پلاک و خودرو، تخلف را ثبت نکنید.
    توضیح: حتما دقت کنید که پلاک را صحیح وارد کرده باشید و سپس از نوع و رنگ خودروی منطبق با پلاک وارد شده، اطمینان حاصل کنید.<br>


    3. در صورت بروز اشتباه سهوی در ثبت پلاک، ناظر می بایست فوراً با پشتیبان سامانه ناظر به شماره 02121864111 تماس حاصل نموده ومراتب رابرای حذف تخلفی که به اشتباه ثبت شده اعلام نمایید.<br>


    4. شما نماینده نیروی انتظامی در ثبت تخلف کشف حجاب در خودرو هستید؛ پس اگر بخاطر اغراض شخصی مانند انتقام‌گیری یا خصومت یا شوخی ... به عمد، اقدام به ثبت تخلف نادرست بنمایید، این اقدام از نظر قانون جرم بوده و قابل پیگیری قضایی است؛ همچنین باعث خدشه به جایگاه معرف شما و مجموعه فعال مردمی می‌شود.<br>
    5. ثبت تخلف، فقط با رؤیت و اطمینان شما از انجام تخلف قابل ثبت است؛ پس بنا به گزارش و سفارش دیگران، هر چند مورد اطمینان شما باشند، حق ثبت تخلف را ندارید.<br>


     6. در هر روز، برای هر پلاک، شما امکان ثبت تنها یکبار تخلف را دارید و بعد از اولین ثبت تخلف، هر چند در ساعات دیگر، برای آن خودرو امکان ثبت تخلف برای شما مقدور نیست. در صورتی که در لحظه وقوع تخلف، موفق به ثبت در سامانه نشدید، در زمان دیگری طی همان روز (و نه روزهای بعد) با ذکر ساعت و مکان لحظه وقوع تخلف گزارش را ثبت نمایید.<br>


    7. اطمینان از این که صاحب یا سرنشین یک خودرو بخاطر لجبازی یا عدم احترام به قوانین، همیشه در خودرو خود، کشف حجاب می‌کند، دلیل بر ثبت تخلف در آن روز یا روزهای آتی نیست! دقت کنید، ملاک برای ثبت تخلف، رؤیت و اطمینان از کشف حجاب است.<br>
    8. ناظر به هیچ وجه نبایدگوشی تلفن همراه خود را برای ثبت تخلف در اختیار سایرین قرار دهد.<br>


    9. ناظرمی بایست تخلفات را همان زمانی که مشاهده نموده ثبت نماید واز درج آن در روزهای دیگر ممانعت نماید.<br>


    10. تجسس برای ثبت تخلف جایز نیست؛ از این رو اگر به طور معمول شاهد تخلف کشف حجاب بودید آن را ثبت کنید؛ اما تجسس و دقت بسیار درباره راننده و سرنشینان یک خودرو، برای ثبت تخلف کشف حجاب، شایسته نیست(همینطور در رابطه با خودروهای با شیشه دودی).<br>


    11. تجسس برای ثبت تخلف، جایز نیست؛ از این رو اگر به طور معمول شاهد تخلف کشف حجاب بودید آن را ثبت کنید؛ اما تجسس و دقت بسیار درباره راننده و سرنشینان یک خودرو، برای ثبت تخلف کشف حجاب، شایسته نیست. حتی در صورت دودی بودن شیشه‌ها به نحوی که داخل اتومبیل مشخص نیست، شما مجاز به تفحص نیستید.<br>


    12. ضرورتی ندارد که دنبال خودرو متخلف بروید تا اطمینان حاصل کنید که او همچنان به تخلف خود ادامه داده یا خودش بدون تذکر، دوباره شال یا روسری را روی سر خواهد گذاشت. ملاک مشاهده اولیه است که شما بر اساس همان مشاهده مجاز به ثبت تخلف هستید.<br>
    13. فعال نبودن و عدم ثبت تخلف در بازه شش ماه، باعث حذف شما از سیستم سامانه برخط ناظر یک خواهد شد.<br>


  </p>
  <p class="bold-p">
    اینجانب تمام موارد بالا را قبول دارم و تعهد می دهم خلاف آن
    عمل نکنم و هرگونه عواقب عدم دقت در ثبت پلاک را بر عهده میگیرم.
  </p>
  <br/>
  <Form @submit="onSubmit">
    <!--<Field as="checkbox" type="checkbox" class="form-check-input" :value="false" name="flexCheckDefault" :rules="isRequired"/>-->
    <input type="checkbox" v-model="isAcceptedRules" class="form-check-input" required/>
    <label class="form-check-label" for="flexCheckDefault">قوانین را پذیرفتم</label>
    <p class="text-danger text-center mt-3"><b>{{ errorMessage }}</b></p>
    <ErrorMessage name="terms"/>
  </Form>
  <div class="col-12 text-start">
    <button @click="handleStep3" class="btn btn-success px-3">صفحه بعد</button>
  </div>
</template>

<script>
import {Form, Field, ErrorMessage} from 'vee-validate';
import router from '@/router';
import axios from 'axios';
import PageLoader from '../components/Loader'
import HeadWithLogo from "@/components/HeadWithLogo";
export default {
  data() {
    return {
      isloading: false,
      isAcceptedRules:false,
      errorMessage:""
    }
  },
  components: {
    HeadWithLogo,
    Form,
    Field,
    ErrorMessage,
    PageLoader
  },
  mounted() {
    if (localStorage.name) {
      this.fullname = localStorage.name
    }
    if (!localStorage.token) {
      router.push('/PhoneNumber')
    }
  },
  methods:{
    isRequired(value) {
      if (value && value.trim()) {
        return true;
      }
      return 'لطفا شماره تلفن خود را وارد نمایید';
    },
    handleStep3(){
      this.isloading=true
      if(this.isAcceptedRules===false){
        this.errorMessage="لطفاً نخست قوانین را بپذیرید"
        this.isloading=false
        return
      }
      const headers = {
        accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.token
      }
      axios.get(process.env.VUE_APP_ROOT_API+"/sanctum/csrf-cookie").then(() => {
      axios
        .get(process.env.VUE_APP_ROOT_API+'/api/step3', {
           headers: headers
          })
        .then(response => {
              this.messages = response.data
              this.isloading=false
              if(this.messages.status=="done"){
                alert(this.messages.message)
                router.push("/exam-rule")
              }
        })
        .catch((err) => {
          this.isloading=false
          this.errorMessage="خطایی رخ داده است"
         })
      })
    }
  }
}
</script>

<style scoped>

</style>